import type { ReactNode } from 'react'
import AnimatedContent from './AnimatedContent/AnimatedContent'
import FadeContent from './FadeContent/FadeContent'
import { usePrefiereMenosMovimiento } from './preferencias'

type Props = {
  children: ReactNode
  /** 'subir' desplaza y aparece; 'fundir' solo aparece (para zonas densas como tablas). */
  tipo?: 'subir' | 'fundir'
  /** Segundos de espera antes de empezar. */
  retraso?: number
  className?: string
}

/** Revela su contenido al entrar en pantalla. Con movimiento reducido, el contenido ya está en su sitio. */
export function Entrada({ children, tipo = 'subir', retraso = 0, className }: Props) {
  const menos = usePrefiereMenosMovimiento()
  if (menos) return <div className={className}>{children}</div>
  if (tipo === 'fundir') {
    return (
      <FadeContent className={className} duration={0.5} delay={retraso} threshold={0.1}>
        {children}
      </FadeContent>
    )
  }
  return (
    <AnimatedContent className={className} distance={32} duration={0.7} delay={retraso} threshold={0.1} ease="power3.out">
      {children}
    </AnimatedContent>
  )
}
